import { WordPartOfSpeech } from '../services/contentService';

export const WORD_POS_OPTIONS: { value: WordPartOfSpeech; label: string }[] = [
  { value: WordPartOfSpeech.Noun, label: 'Noun' },
  { value: WordPartOfSpeech.Verb, label: 'Verb' },
  { value: WordPartOfSpeech.Adjective, label: 'Adjective' },
  { value: WordPartOfSpeech.Adverb, label: 'Adverb' },
  { value: WordPartOfSpeech.Phrase, label: 'Phrase' },
  { value: WordPartOfSpeech.Other, label: 'Other' }
];

export const WORD_POS_I18N: Record<WordPartOfSpeech, { en: string; fa: string }> = {
  [WordPartOfSpeech.Noun]: { en: 'Noun', fa: 'اسم' },
  [WordPartOfSpeech.Verb]: { en: 'Verb', fa: 'فعل' },
  [WordPartOfSpeech.Adjective]: { en: 'Adjective', fa: 'صفت' },
  [WordPartOfSpeech.Adverb]: { en: 'Adverb', fa: 'قید' },
  [WordPartOfSpeech.Phrase]: { en: 'Phrase', fa: 'عبارت' },
  [WordPartOfSpeech.Other]: { en: 'Other', fa: 'دیگر' }
};

export function newVocabEntryKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `k-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
